import { Theme } from '../../token/theme'
import { ChipShape } from './type'
export const getDisabledChipStyles = (theme: Theme) => {
    return {
        backgroundColor: theme.color.background.neutral,
        borderWidth: theme.border.width.sm,
        borderColor: theme.color.border.disabled,
        cursor: 'not-allowed'
    }
}

export const getSelectedChipStyles = (theme: Theme) => {
    return {
        backgroundColor: theme.color.chip.selectedPrimaryBg,
        borderWidth: theme.border.width.sm,
        borderColor: theme.color.chip.selectedPrimaryBorder,
        cursor: 'pointer'
    }
}

export const getDefaultChipStyles = (theme: Theme) => {
    return {
        backgroundColor: theme.color.background.neutral,
        borderWidth: theme.border.width.sm,
        borderColor: theme.color.chip.nonSelectedPrimaryBorder,
        cursor: 'pointer'
    }
}

export const getChipLabelColor = ({
    isSelected,
    isDisabled,
    theme
}: {
    isSelected: boolean
    isDisabled: boolean
    theme: Theme
}) => {
    if (isDisabled) {
        return theme.color.chip.disabledPrimaryLabel
    }

    if (isSelected) {
        return theme.color.chip.selectedPrimaryLabel
    }

    return theme.color.chip.nonSelectedPrimaryLabel
}

export const getCounterStyles = ({ theme }: { theme: Theme }) => {
    return {
        backgroundColor: theme.color.chip.selectedPrimaryLabel
    }
}

export const getChipStyles = ({
    shape,
    isSelected,
    isDisabled,
    showTopIcon,
    theme
}: {
    shape: `${ChipShape}`
    isSelected: boolean
    isDisabled: boolean
    showTopIcon: boolean
    theme: Theme
}) => {
    const defaultChipStyles = {
        paddingTop: showTopIcon ? theme.spacing[2] : theme.spacing[2],
        paddingBottom: showTopIcon ? theme.spacing[2] : theme.spacing[2],
        borderRadius:
            shape === ChipShape.ROUND
                ? theme.border.radius[28]
                : theme.border.radius[8]
    }

    if (isDisabled) {
        return {
            ...defaultChipStyles,
            ...getDisabledChipStyles(theme)
        }
    }

    if (isSelected) {
        return {
            ...defaultChipStyles,
            ...getSelectedChipStyles(theme)
        }
    }

    return {
        ...defaultChipStyles,
        ...getDefaultChipStyles(theme)
    }
}
